export enum RoleType {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  PAYMENTS = 'PAYMENTS',
  PRICING = 'PRICING',
  CUSTOMER = 'CUSTOMER',
  SYNC = 'SYNC',
  ADMIN_API = 'ADMIN_API',
  QUOTATION_API = 'QUOTATION_API',
}
